import { Box, Divider } from '@frontend/legacy-components';

import GroupDisplay from './components/GroupDisplay';

type SetIDState = React.Dispatch<React.SetStateAction<number | null>>;
interface Address {
  address1: string;
  address2: string | null;
  city: string;
}
interface Country {
  abbr: string;
  name: string;
}
interface State {
  abbr: string;
  name: string;
}

interface Logo {
  id: number;
  original: string;
  thumbnail: string;
}

interface Facility {
  address: Address;
  country: Country;
  city: string;
  postalCode: string;
  state: State;
  id: number;
  isDefault: boolean;
  logo: Logo;
  name: string;
  phone: string;
  phoneExt: string | number | null;
  url: string;
}

interface Group {
  businessName: string;
  facilities: Facility[];
}
interface OptionalGroup {
  id: number;
  group: Group;
}

interface OptionalGroupCardProps {
  optionalGroup: OptionalGroup;
  highlightedGroupMemberId: number | null;
  isLast: boolean;
  selectedGroupMemberId: number | null;
  setHighlightedGroupMemberId: SetIDState;
  setSelectedGroupMemberId: SetIDState;
}

const OptionalGroupCard = ({
  highlightedGroupMemberId,
  isLast,
  selectedGroupMemberId,
  setHighlightedGroupMemberId,
  setSelectedGroupMemberId,
  optionalGroup,
}: OptionalGroupCardProps) => {
  const { id, group } = optionalGroup;
  const { businessName, facilities } = group;

  const defaultFacility = facilities.find(
    (facility: Facility) => facility.isDefault === true,
  );

  const addressData = defaultFacility?.address;

  let displayAddress = '';
  if (addressData) {
    const { address1, address2, state, city, postalCode } = addressData;
    if (address1) {
      displayAddress = address1;

      if (address2) {
        displayAddress = displayAddress + ', ' + address2;
      }
    }

    if (city) {
      displayAddress = displayAddress ? displayAddress + ' ' + city : city;
    }

    if (state) {
      displayAddress = displayAddress
        ? displayAddress + ', ' + state?.abbr
        : state?.abbr;
    }

    if (postalCode) {
      displayAddress = displayAddress
        ? displayAddress + ' ' + postalCode
        : postalCode;
    }
  }

  const logoURL = defaultFacility?.logo?.original;

  const handleSelect = () => {
    if (id === selectedGroupMemberId) {
      setSelectedGroupMemberId(null);
      setHighlightedGroupMemberId(null);
      return;
    }

    setSelectedGroupMemberId(id);
    setHighlightedGroupMemberId(id);
  };

  const isHighlighted = highlightedGroupMemberId === id ? true : false;

  return (
    <Box
      cursor="pointer"
      onClick={() => handleSelect()}
      _hover={{ bg: 'interaction.surfaceHover' }}
      bg={isHighlighted ? 'interaction.surfaceHover' : undefined}
      tabIndex={0}
      as="button"
    >
      <GroupDisplay
        logoURL={logoURL}
        businessName={businessName}
        displayAddress={displayAddress}
      />
      {!isLast && <Divider />}
    </Box>
  );
};

export default OptionalGroupCard;
